import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/fuegodocs/theme/src/components/Layout/Layout.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InfoBox = makeShortcode("InfoBox");
const Box = makeShortcode("Box");
const StyledAvatarExample = makeShortcode("StyledAvatarExample");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Avatars represent a user or a team. Stacked avatars represent groups of people.`}</p>
    <h2>{`Import`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {Avatar} from '@fuegokit/react'
`}</code></pre>
    <InfoBox variant="discovery" url={`https://fuegokit.design/react-storybook`} linkText={`explore the examples at Storybook.`} withIcon mdxType="InfoBox">
  Additional styling guides and examples are coming soon. For now,
    </InfoBox>
    <h2>{`Usage`}</h2>
    <Box sx={{
      p: 4,
      border: '1px solid',
      borderRadius: 2,
      borderColor: 'border.default'
    }} mdxType="Box">
  <StyledAvatarExample mdxType="StyledAvatarExample" />
    </Box>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Avatar>
  <Avatar.Image src={\`https://www.yourimageurl.com/img.png\`} alt={\`Masha Shaposhnikova\`} />
  <Avatar.Fallback delayMs={600}>MS</Avatar.Fallback>
</Avatar>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      